export const DateFormat = {
  DAY_DATE_SHORT_MONTH_YEAR: "ddd, D MMM YYYY", // Wed, 1 Jan 2023
  DAY_DATE: "ddd, DD ", //  Sun, 01
  DATE_SHORT_MONTH_LOWER: "dd MMM", //  Su Jan
  DATE_LONG_MONTH_DAY_NAME: "d LLL ccc", //  0 January 1, 2023 5:30 AM ccc
  DATE_LONG_MONTH: "d LLL", //  0 January 1, 2023 5:30 AM
  LONG_MONTH_YEAR: "LLLL yyyy", //  Sunday, January 1, 2023 5:30 AM 2023
  SHORT_MONTH_YEAR: "MMM yyyy", //  777, 0 January 1, 2023 5:30 AM
  DAY_DATE_LONG_MONTH: "EEE, d LLL", //  777, Su January 1, 2023 5:30 AM 2023
  DAY_DATE_LONG_MONTH_YEAR: "EEE, dd LLL yyyy", //  KK:30 amam, Su January 1, 2023 5:30 AM 2023
  TIME_DATE_LONG_MONTH_YEAR: "KK:mm aa, dd LLL yyyy", //  777, Su Jan
  DAY_DATE_SHORT_MONTH: "EEE, dd MMM", //  Su Jan 2023, KK:30:00 amamam
  TIMESTAMP_SEC: "dd MMM yyyy, KK:mm:ss aaa", //  January 1, 2023 5:30 AM
  LONG_MONTH: "LLL", //  Su Jan 2023
  DATE_SHORT_MONTH_YEAR: "dd MMM yyyy", //  1, Jan 2023, 5:30 AM
  DATE_SHORT_MONTH_YEAR_TIME: "D, MMM YYYY, h:mm A", //  Su Jan, 2023
  DATE_SHORT_MONTH_COMMA_YEAR: "dd MMM, yyyy", //  iii, 0 Jan 2023
  SHORT_DAY_DATE_SHORT_MONTH_YEAR: "iii, d MMM yyyy", //  2023-01-Su
  DASH_YYYY_MM_DD: "yyyy-MM-dd", //  777, 0 Jan 2023
  DAY_DATE_SHORT_MONTH_YEAR_FULL: "EEE, d MMM yyyy", //  777, 0 Jan
  DAY_DATE_SHORT_MONTH_SHORT: "EEE, d MMM", //  0 000
  DATE_SHORT_DAY: "d eee", //  0th Jan
  DATE_ORDINAL_SHORT_MONTH: "do MMM", //  0 Jan 2023
  DATE_SHORT_MONTH_YEAR_CAPS: "d MMM YYYY", //  0 01 2023 5:30 AM x
  DATE_MONTH_YEAR_LT: "d MM YYYY LT", //  KK:30 am, 0 January 1, 2023 5:30 AM 2023 y
  TIME_DATE_LONG_MONTH_YEAR_SHORT: "KK:mm a, d LLL yyyy", // 03:00 PM, 18 Nov 2022
  DATE_SHORT_MONTH: "DD MMM", // 1 01
  FULL_MONTH_YEAR: "MMMM yyyy", //  January 2023
  DATE_SHORT_MONTH_YEAR_LOWER: "dd MMM yyyy", //  Su Jan 2023
  SHORT_MONTH_YY: "MMM YY", //  Jan 23
  SHORT_MONTH_YEAR_LOWER: "MMM yyyy", //  Jan 2023
  DATE_ORDINAL_SHORT_MONTH_LOWER: "Do MMM", //  1st Jan
  DATE_ORDINAL_SHORT_MONTH_YEAR: "Do MMM YYYY", //  1st Jan 2023
  DATE_SHORT_MONTH_YEAR_SINGLE: "D MMM YYYY", //  1 Jan 2023
  SINGLE_D: "d", //  0
  SLASH_DD_MM_YYYY: "dd/MM/yyyy", //  Su/01/2023
  SLASH_DD_MM_YYYY_HH_MM_SS: "dd/MM/yyyy HH:mm:ss", //  Su/01/2023 05:30:00
  SLASH_DD_MM_YYYY_HH_MM_SS_CAPS: "DD/MM/YYYY HH:mm:ss", //  01/01/2023 05:30:00
  SLASH_DD_MM_YYYY_CAPS: "DD/MM/YYYY", //  01/01/2023
  DATE_ORDINAL_LONG_MONTH: "Do MMMM",
  DATE_SHORT_MONTH_SINGLE: "D MMM",
  ISO_TIMESTAMP: "YYYY-MM-DDTHH:mm:ss.SSSZ", // 2023-08-14T00:00:00.000Z
  SHORT_MONTH_DATE_YEAR: "MMM DD, yyyy", // Jan 01, 2023
  DATE_SHORT_MONTH_YEAR_FULL_CAPS: "DD MMM YYYY", // 01 Jan 2023
  DAY_DATE_ORDINAL_SHORT_MONTH: "ddd, Do MMM", // Fri , 21st Mar
  SHORT_DAY: "ddd", // Mon
  DATE_FULL_DAY: "dd EEEE", // Tu Tuesday
  DASH_YYYY_MM_DD_CAPS: "YYYY-MM-DD", // 2024-01-29
  DATE_FULL_DAY_CAPS: "DD dddd", // 29 Tuesday
  DAY_DATE_SHORT_MONTH_YEAR_COMMA: "ddd, D MMM YYYY", // Mon , 23 Feb 2024
  FULL_GMT_STRING: "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (India Standard Time)", // IST
  DAY_DASH_DD_MM_YYYY: "EEE, dd-MM-yyyy",
  DASH_DD_MM_YYYY: "DD-MM-YYYY",
  DASH_YYYY_M: "YYYY-M",
  TIME_DATE_LONG_MONTH_YEAR_HH_MM_A: "hh:mm a, d LLL yyyy", // 15:00, 18 Nov 2022
  DAY_DATE_SHORT_MONTH_CAPS: "ddd, D MMM", // Thu , 1 May ,
  FULL_DAY: "dddd", // Monday,
  DASH_DD_MM_YYYY_HH_MM_SS: "dd-MM-yyyy HH:mm:ss",
  ISO_TIMESTAMP_NO_MS: "YYYY-MM-DDTHH:mm:ss[Z]", // 2023-08-14T00:00:00Z
  DATE_FULL_MONTH_YEAR: "DD MMMM YYYY",
  DATE_SHORT_MONTH_YEAR_ALT: "d MMM yyyy", // 1 Oct 2025
  SLASH_DD_MM_YYYY_ALT: "DD/MM/YYYY", // 01/10/2025
  SLASH_DD_MM_YY: "DD/MM/YY", // 22/05/25
  SLASH_DD_MM_YYYY_HH_MM_A: "DD/MM/YYYY hh:mm A", // 01/10/2025 03:30 PM
  SLASH_MM_DD_YY: "MM/DD/YY",
  SLASH_YY_MM_DD: "YY/MM/DD",
  DAY_DATE_SINGLE: "ddd D",
  DATE_SINGLE: "D",
  WEEK_SINGLE: "w",
  MONTH_SHORT_CAPS: "MMM",
  YEAR_CAPS: "YYYY",
  DATE_MONTH_TIME_AM_PM: "D MMMM h:mm a",
  DAY_DATE_MONTH: "ddd D MMMM",
  MONTH_YEAR_CAPS: "MMMM YYYY",
}

export const TimeFormat = {
  TWELVE_HOUR_AM_PM_LOWER: "hh:mm a", // 05:30 am
  TWELVE_HOUR_LOWER: "hh:mm", // 05:30
  TWELVE_HOUR_SEC_LOWER: "hh:mm:ss", // 05:30:00
  TWELVE_HOUR_AM_PM_CAPS: "hh:mm A", // 05:30 AM
  MILITARY_TIME: "HH:mm", // 17:30
  MILITARY_TIME_SEC: "HH:mm:ss", // 17:30:00
  TWELVE_HOUR_AM_PM_SEC_SINGLE: "h:mm:ss a",
  TWELVE_HOUR_AM_PM_SINGLE: "h:mm a",
  TWELVE_HOUR_AM_PM_SEC_CAPS: "hh:mm:ss A", // 11:49:17 PM
}

export const DateTimeFormat = {
  SHORT_MONTH_YEAR_TIME: "dd MMM yyyy, h:mm aa", // 01 Jan 2023, 5:30 am
  DATE_TIME_AM_PM: "DD MMM YYYY, hh:mm A", // 01 Jan 2023, 05:30 AM
  TIME_AM_PM_DATE: "hh:mm A, DD MMM YYYY", // 05:30 AM, 01 Jan 2023
  DASH_YYYY_MM_DD_HH_MM: "YYYY-MM-DD HH:mm", // 2023-01-01 05:30
}
